var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7937 14C15.7937 18.3488 12.2588 21.875 7.896 21.875C6.86046 21.8764 5.83479 21.6738 4.87755 21.2788C3.92031 20.8838 3.05024 20.3041 2.31703 19.5728C1.58382 18.8416 1.00182 17.973 0.604264 17.0169C0.206707 16.0607 0.00137796 15.0355 0 14C0 9.64951 3.535 6.12501 7.896 6.12501C8.93169 6.1234 9.95754 6.32583 10.915 6.72073C11.8724 7.11564 12.7427 7.69529 13.4761 8.42657C14.2095 9.15786 14.7917 10.0265 15.1893 10.9828C15.587 11.9391 15.7924 12.9643 15.7937 14V14ZM24.4563 14C24.4563 18.095 22.6887 21.413 20.5082 21.413C18.3277 21.413 16.5603 18.0933 16.5603 14C16.5603 9.90501 18.3277 6.58701 20.5082 6.58701C22.6887 6.58701 24.4563 9.90676 24.4563 14ZM28 14C28 17.668 27.3788 20.6413 26.6105 20.6413C25.844 20.6413 25.2228 17.6663 25.2228 14C25.2228 10.332 25.844 7.35876 26.6122 7.35876C27.3787 7.35876 28 10.332 28 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c8a8b5a1.svg";
export { ForwardRef as ReactComponent };